// src/pages/AdminPage/components/Pagination.tsx

interface PaginationProps {
  page: number;
  total: number;
  limit: number;
  onChange: (page: number) => void;
}

export default function Pagination({
  page,
  total,
  limit,
  onChange,
}: PaginationProps) {
  if (total <= limit) return null;

  const totalPages = Math.ceil(total / limit);
  const startItem = (page - 1) * limit + 1;
  const endItem = Math.min(page * limit, total);
  const canPrev = page > 1;
  const canNext = page < totalPages;

  return (
    <div
      style={{
        padding: "12px 16px",
        borderTop: "1px solid #1E2D45",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
        gap: 8,
      }}>
      <span style={{ color: "#475569", fontSize: 12 }}>
        {startItem}–{endItem} / {total}
      </span>
      <div style={{ display: "flex", gap: 6 }}>
        <button
          disabled={!canPrev}
          onClick={() => onChange(page - 1)}
          style={{
            padding: "6px 12px",
            borderRadius: 8,
            border: "1px solid #1E2D45",
            background: "transparent",
            color: canPrev ? "#E2E8F0" : "#334155",
            cursor: canPrev ? "pointer" : "not-allowed",
            fontSize: 12,
          }}>
          Oldingi
        </button>
        <span
          style={{
            padding: "6px 12px",
            color: "#64748B",
            fontSize: 12,
          }}>
          {page} / {totalPages}
        </span>
        <button
          disabled={!canNext}
          onClick={() => onChange(page + 1)}
          style={{
            padding: "6px 12px",
            borderRadius: 8,
            border: "1px solid #1E2D45",
            background: "transparent",
            color: canNext ? "#E2E8F0" : "#334155",
            cursor: canNext ? "pointer" : "not-allowed",
            fontSize: 12,
          }}>
          Keyingi
        </button>
      </div>
    </div>
  );
}
